import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const NotFound = () => {
  const [count, setCount] = useState(5);
  useEffect(() => {
    const t = setInterval(() => setCount(c => { if (c <= 1) { clearInterval(t); window.location.href = '/'; } return c - 1; }), 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center">
      <div className="text-8xl font-serif font-bold text-[#1F4D3F] opacity-10 mb-4">404</div>
      <h1 className="text-3xl font-serif font-semibold text-[#1F4D3F] mb-2">Page introuvable</h1>
      <p className="text-[#7A6F5C] mb-6">Redirection dans {count}s...</p>
      <Link to="/" className="bg-[#1F4D3F] text-white px-6 py-2.5 rounded-xl font-medium hover:bg-[#173B30]">Retour à l'accueil</Link>
    </div>
  );
};
export default NotFound;
